import { getAbsoluteUrl } from "./services";
const buildUrl = (videoUrl) => {
  const url = new URL("/rich-content/oembed", location.href);
  url.searchParams.append("url", getAbsoluteUrl(videoUrl));
  url.searchParams.append("options.maxWidth", "980");
  return url;
};
const fetchOembed = (url, instance) => {
  return fetch(buildUrl(url), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: instance
    }
  }).then((res) => res.json());
};
const providerBlackList = ["wix", "facebook"];
const fetchEmbedData = (instance) => async (url) => {
  try {
    return fetchOembed(url, instance).then((json) => {
      const { html, ...rest } = json;
      const { provider_name } = rest;
      const res = providerBlackList.includes((provider_name || "").toLowerCase()) ? { ...rest } : { ...rest, html };
      return res;
    });
  } catch (e) {
    return new Promise((resolve) => {
      setTimeout(() => resolve({}), 1);
    });
  }
};
export {
  fetchEmbedData,
  fetchOembed
};
//# sourceMappingURL=fetchEmbedData.js.map
